import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const attempts = ['Intentaste ponerlo en el orinal cada 5 minutos, pero solo lograste que odiara el baño.', 'Probaste los pañales de aprendizaje "Pull-ups", que para el cerebro del niño se sienten exactamente igual que un pañal normal.', 'Seguiste consejos de internet que te decían "espera a que él esté listo", mientras el gasto en pañales seguía subiendo cada mes.'];
export function FailedAttempts() {
  return <section className="py-20 bg-cream" data-id="element-14">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate mb-4" data-id="element-17">
            Por qué lo que intentaste no funcionó
          </h2>
          <p className="text-lg text-slate-light max-w-2xl mx-auto" data-id="element-18">
            No es tu culpa. Has estado siguiendo consejos obsoletos que van en
            contra de la naturaleza de tu hijo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-19">
          {attempts.map((attempt, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-pink-light/50 relative" data-id="element-20">
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-white rounded-full p-1" data-id="element-21">
                <XCircle size={40} className="text-pink" strokeWidth={1.5} data-id="element-22" />
              </div>
              <p className="text-slate-light text-lg text-center mt-4 leading-relaxed" data-id="element-23">
                {attempt}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}